import React, { useState } from "react";
import { AppBar, Stack, Tooltip, IconButton, Toolbar } from "@mui/material";
import HelpIcon from "@mui/icons-material/HelpOutline";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";

import AAHelpDrawer from "../Drawer/AAHelpDrawer";
import AANavHeader from "./AANavHeader";

import { ActionIconStyle } from "../utils/AAStyles";

interface AAAppBarProps {}

const AAAppBar: React.FC<AAAppBarProps> = () => {
  const theme = useTheme();
  const [openHelp, setOpenHelp] = useState<boolean>(false);
  const navBarWidth = 0;

  const handleHelpClick = () => {
    setOpenHelp(!openHelp);
  };

  const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    alignItems: "flex-start",
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    alignContent: "center",
    justifyContent: "center",
    "@media all": {
      minHeight: 56,
      opacity: 100,
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 22,
      paddingRight: 27,
    },
  }));

  return (
    <AppBar
      position="fixed"
      color="inherit"
      id="imanage-cloud-app-bar"
      elevation={0}
      sx={{
        width: "100%",
        zIndex: theme.zIndex.drawer + 1,
        marginLeft: navBarWidth,
        transition: theme.transitions.create(["margin", "width"], {
          easing: openHelp
            ? theme.transitions.easing.easeOut
            : theme.transitions.easing.sharp,
          duration: openHelp
            ? theme.transitions.duration.enteringScreen
            : theme.transitions.duration.leavingScreen,
        }),
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "#2a6ebb",
      }}
    >
      <StyledToolbar>
        <AANavHeader />
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          sx={{ border: 0, marginLeft: 0, marginTop: 0.5, paddingBottom: 0 }}
        >
          <Tooltip title="Help & support" arrow placement="bottom-end">
            <IconButton
              aria-label="help and support"
              onClick={handleHelpClick}
              size="large"
            >
              <HelpIcon sx={ActionIconStyle()} />
            </IconButton>
          </Tooltip>
        </Stack>
        <AAHelpDrawer open={openHelp} handleDrawerClose={handleHelpClick} />
      </StyledToolbar>
    </AppBar>
  );
};

export default AAAppBar;
